import React, { Component } from 'react';

import Button from 'components/common/Button/Button';
import AngleDown from 'react-icons/lib/fa/angle-down';
import Checkbox from 'components/common/Checkbox/Checkbox';

import cn from 'classnames';
import styles from './Sea.scss';
import tracker from '../../../../../services/tracker';
import { withTranslation } from 'react-i18next';
import i18n from '../../../../../i18n';
import { gaEvent, trackGA } from 'services/ga';

const getVariants = (t) => ({
  500: {
    param: '500',
    key: '500',
    text: t('components.header.filtersBar.filters.sea.500'),
    event: 'Web_Filters_Up_To_500',
  },
  1500: {
    param: '1500',
    key: '1500',
    text: t('components.header.filtersBar.filters.sea.1500'),
    event: 'Web_Filters_Up_To_1500',
  },
  3000: {
    param: '3000',
    key: '3000',
    text: t('components.header.filtersBar.filters.sea.3000'),
    event: 'Web_Filters_Up_To_3000',
  },
});

export const parseSearch = (search) => {
  const { sea } = search;
  return { sea };
};

export const compileSearch = (data) => {
  const { sea } = data;
  return { sea };
};

export const compileRequest = (data) => {
  const { sea } = data;
  return { distanceToSea: sea };
};

export const getRequest = (search) => compileRequest(parseSearch(search));

export const subtext = (search) => {
  const { sea } = parseSearch(search);
  return (sea && sea.text) || i18n.t('components.header.filtersBar.filters.sea.notSelected');
};

class Sea extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: false,
    };

    this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
    this.handleClearClick = this.handleClearClick.bind(this);
    this.toggleExpand = this.toggleExpand.bind(this);
  }

  handleClearClick(e) {
    e.stopPropagation();
    const { dropdownData, mode, profile, objectType } = this.props;
    const data = { sea: undefined };
    const compiledSearch = compileSearch(data);
    const compiledRequest = compileRequest(data);
    dropdownData(compiledSearch, compiledRequest);
    this.props.onClearClick('sea');

    trackGA(
      gaEvent.filterClearButtonsClick({
        eventContent: 'eshchyo',
        eventContext: mode,
        productType: objectType,
        user_id: profile.id,
      })
    );
  }

  handleCheckboxClick(key, checked) {
    const { dropdownData, eventData, mode, objectType, profile, t } = this.props;
    const data = { sea: checked ? key : undefined };
    const variants = getVariants(t);

    tracker.sendVariantEvent({ variants, key, selected: checked, eventData });

    const variant = variants[Object.keys(variants).find((v) => variants[v].key === key)];
    const variantName = variant ? variant.text : 'Unknown variant';
    const isChecked = checked ? 'on' : 'off';

    trackGA(
      gaEvent.filterCheckboxesClick({
        eventContent: [variantName, ` | ${isChecked}`],
        eventContext: mode,
        productType: objectType,
        user_id: profile.id,
      })
    );

    const compiledSearch = compileSearch(data);
    const compiledRequest = compileRequest(data);
    dropdownData(compiledSearch, compiledRequest);
  }

  checkbox(key) {
    const { search, additional, t } = this.props;
    const { sea } = parseSearch(search);
    const variants = getVariants(t);

    const variant = variants[key];
    return (
      <Checkbox
        className={styles.Checkbox}
        innerStyle={styles.FiltersCheckInner}
        classNameClone="CheckboxCloneFilters"
        checked={sea === key}
        type="radio"
        additional={additional}
        handle={this.handleCheckboxClick.bind(undefined, variant.key)}
        text={variant.text}
      />
    );
  }

  toggleExpand() {
    this.setState((prevState) => ({ isExpanded: !prevState.isExpanded }));
  }

  render() {
    const { className, additional, search, t } = this.props;
    const { sea } = parseSearch(search);
    const { isExpanded } = this.state;
    const selectedCount = sea ? 1 : 0;

    return (
      <div className={cn(styles.Menu, className, { [styles.Additional]: additional })}>
        <div className={styles.Header} onClick={this.toggleExpand}>
          <span className={styles.Title}>
            {t('components.header.filtersBar.filters.sea.title')}
            {selectedCount > 0 && ` (${selectedCount})`}
            <AngleDown className={cn(styles.Icon, { [styles.Active]: isExpanded })} />
          </span>
          {additional && sea && (
            <Button className={styles.Button} onClick={this.handleClearClick}>
              {t('components.header.filtersBar.filters.sea.clear')}
            </Button>
          )}
        </div>
        {isExpanded && (
          <div className={styles.Checkboxes}>
            <div className={styles.FirstColumn}>{this.checkbox('500')}</div>
            <div className={styles.SecondColumn}>{this.checkbox('1500')}</div>
            <div className={styles.ThirdColumn}>{this.checkbox('3000')}</div>
          </div>
        )}
        {/* {additional ? (
          <div className={styles.ButtonWrap}>
            {!!sea &&
              <Button className={styles.Button} onClick={this.handleClearClick}>
                {t('components.header.filtersBar.filters.sea.clear')}
              </Button>}
          </div>
        ) : (null)} */}
      </div>
    );
  }
}

export default withTranslation()(Sea);



// WEBPACK FOOTER //
// ./src/components/Header/FiltersBar/Filters/Sea/Sea.js